import type { CRMUser } from "@swivl-mono/types";
import React from "react";
import { IoMdCheckmark } from "react-icons/io";

interface CustomerListItemProps {
  user: CRMUser;
  selected?: boolean;
  onSelect: (user: CRMUser) => void;
}

export function CustomerListItem({ user, selected, onSelect }: CustomerListItemProps): React.ReactNode {
  const contactParts = [user.phoneNumbers?.[0], user.emails?.[0]].filter(Boolean).join(" | ");
  const locationName = user.locations?.[0]?.name;

  return (
    <button type="button" onClick={() => onSelect(user)} className="w-full cursor-pointer px-4 text-left active:bg-orange-50">
      <div className="flex items-center justify-between border-b border-grey-200 pt-2 pb-2">
        <div className="min-w-0 flex-1">
          <p className="heading-base-alt text-black">{user.name || "Unknown"}</p>
          {contactParts && <p className="body-sm text-grey-600">{contactParts}</p>}
          {locationName && <p className="body-sm text-grey-600">{locationName}</p>}
        </div>
        {selected && <IoMdCheckmark className="ml-2 size-4 shrink-0 text-orange-500" />}
      </div>
    </button>
  );
}
